import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_REVENUE_PETITION_AI_SUMMARIES_ENABLED = createFcmDetails(
	'revenue_petition_ai_summaries_enabled',
	{
		owner: 'Revenue Squad',
		context: 'PSF pages (Carousel, Combo page etc)',
		description: 'Controls whether AI-generated title and description are displayed in the PSF flow.',
		import: false,
		template: {
			enabled: false,
			experiment_name: 'exp_revenue_petition_ai_summaries_enabled_v1',
		},
	},
);
